import { Component } from '@angular/core';

@Component({
  selector: 'app-cards6-examples-36',
  templateUrl: './cards6-examples-36.component.html'
})
export class Cards6Examples36Component {}
